import { render, staticRenderFns } from "./dev-deliver-goods.vue?vue&type=template&id=7ed6b4b3"
import script from "./dev-deliver-goods.vue?vue&type=script&lang=ts"
export * from "./dev-deliver-goods.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports